import React from 'react';
import { getUserDetail } from '../utils/helper';
import { userDetailStore } from '../config/store';
import { withRouter, useHistory } from "react-router-dom";
import { urlparams } from "../config/bootstrap";
  

class Congratulation extends React.Component {
    
    // history = useHistory()
    
    constructor(props) {
        super(props)
        
        this.state = {
            user: null,
            showCongratulations: false
        }
    }
    
    componentDidMount() {
        var ref = this;
        getUserDetail()
        userDetailStore.subscribe(() => {
            var user = userDetailStore.getState();
            ref.setState({ "user": user.userDetail })
        });
        
    }

    componentWillReceiveProps() {
        try {
            let completed = localStorage.getItem('completed')
            let completedSize = JSON.parse(completed).length;
            
            if (completedSize >= 40) {
                // ref.props.history.push('/congratulation' + urlparams)
                // history.push('/congratulation' + urlparams)
                this.setState({
                    showCongratulations: true
                })
            }
        } catch (error) {
        }
    }

    onClickClosePopUp = () => {
        this.props.history.push('/' + urlparams)
        this.setState({
            showCongratulations: false
        })
    }

    render() {
        const {  user, showCongratulations } = this.state;
        return showCongratulations && (
            <div className="container">
            <div className="share_p_wrp">
                <img src="/assets/img/share.png"/>
                <img src="/assets/img/print.png"/>
            </div>
             <div className="congratulation_section">
                 <div className="cong_text_wrp">
                     <h4>{user && user.user_name_display}</h4>
                     <p>lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor </p>
                 </div>
                 <button className="btn_sh_con" onClick={this.onClickClosePopUp}>Close</button>
             </div>
            </div>
        )
    }
}

export default withRouter(Congratulation);